const ProfileIcon2 = ({
  height = "24px",
  width = "24px",
  fillColor = "#183883",
}: {
  height?: string;
  width?: string;
  fillColor?: string; 
}) => {
  return (
      <svg
        style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.25 18.6113C22.25 17.3443 21.482 16.1373 20.089 15.1873C18.263 13.9423 15.322 13.1113 12 13.1113C8.678 13.1113 5.737 13.9423 3.911 15.1873C2.518 16.1373 1.75 17.3443 1.75 18.6113V20.0623C1.75 20.5123 1.929 20.9453 2.248 21.2643C2.567 21.5823 2.999 21.7623 3.45 21.7623L20.55 21.7613C21.001 21.7623 21.433 21.5823 21.752 21.2643C22.071 20.9453 22.25 20.5123 22.25 20.0613V18.6113ZM20.75 18.6123V20.0623C20.75 20.1153 20.729 20.1653 20.691 20.2033C20.654 20.2403 20.603 20.2623 20.55 20.2623H3.45C3.397 20.2623 3.346 20.2403 3.309 20.2033C3.271 20.1653 3.25 20.1153 3.25 20.0623C3.25 20.0613 3.25 18.6123 3.25 18.6123C3.25 17.7813 3.843 17.0493 4.757 16.4273C6.389 15.3133 9.03 14.6113 12 14.6113C14.97 14.6113 17.611 15.3133 19.243 16.4273C20.157 17.0493 20.75 17.7813 20.75 18.6123Z"
          fill={fillColor}
          
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.25C8.964 1.25 6.5 3.714 6.5 6.75C6.5 9.786 8.964 12.25 12 12.25C15.036 12.25 17.5 9.786 17.5 6.75C17.5 3.714 15.036 1.25 12 1.25ZM12 2.75C14.208 2.75 16 4.542 16 6.75C16 8.958 14.208 10.75 12 10.75C9.792 10.75 8 8.958 8 6.75C8 4.542 9.792 2.75 12 2.75Z"
          fill={fillColor}
          />
      </svg>
  );
};
export default ProfileIcon2;
